/* Prevent background color leak outs */
export const backgroundClipStyle = `
  -webkit-background-clip: padding-box; 
  -moz-background-clip:    padding; 
  background-clip:         padding-box;
`;